import { Component, OnInit, ViewChild } from '@angular/core';
import { DisplayModes } from '../../models/enums';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { Permission } from '../../models/permission.model';
import { VisitObjective } from '../../models/lookups/visitObjective.model';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap';
import { AppConfigService } from '../../app.config';
import { ItemFormat } from '../../models/lookups/itemFormat.model';
import { AccountService } from '../../services/account.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { VisitObjectiveService } from './visit-objective.service';

@Component({
  selector: 'crm-visit-objective',
  templateUrl: './visit-objective.component.html',
  styleUrls: ['./visit-objective.component.css']
})
export class VisitObjectiveComponent implements OnInit {

  visitObjectives: VisitObjective[] = [];
  displayMode: DisplayModes = DisplayModes.Success;
  searchText: string;
  pageSize: number;
  public logo = require("../../../app/assets/images/demo/Icon_Items Format.png");

  selectedVisitObjectiveId;
  addNew: boolean = false;
  @ViewChild('deleteModal')
  deleteModal: ModalDirective;
  constructor(private readonly router: Router,
    private readonly alertService: AlertService,
    private readonly translateService: AppTranslationService,
    private readonly appConfig: AppConfigService,
    private readonly visitObjectiveService: VisitObjectiveService,
    private accountService: AccountService) { }

  ngOnInit() {
    this.pageSize = this.appConfig.settings.pageSize;
    this.getVisitObjectives();
  }

  getVisitObjectives() {
    this.displayMode = DisplayModes.Loading;
    this.visitObjectiveService.search(this.searchText).subscribe(responce => {
      this.visitObjectives = responce as VisitObjective[];
      this.displayMode = DisplayModes.Success;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get item formats');
        console.log(err);
      })

  }

  gotoNew() {
    this.addNew = true;
  }

  edit(id) {
    this.selectedVisitObjectiveId = id;
    this.addNew = true;
  }

  confirmDelete(visitObjective) {
    this.selectedVisitObjectiveId = visitObjective;
    this.deleteModal.show();
  }

  delete() {
    this.hideDeleteModal();
    this.displayMode = DisplayModes.Loading;
    this.visitObjectiveService.delete(this.selectedVisitObjectiveId.id).subscribe(response => {
      this.displayMode = DisplayModes.Success;
      this.alertService.showMessage("", this.translateService.getTranslation("clm.deletedSuccessfully"), MessageSeverity.Success);
      let index = this.visitObjectives.indexOf(this.selectedVisitObjectiveId);
      this.visitObjectives.splice(index, 1);
    }, error => {
      this.displayMode = DisplayModes.Error;
      this.alertService.showStickyMessage("Save Error", "The below errors occured while delete item fromat:", MessageSeverity.Error, error);
      this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
    });
  }

  get canManageVisitObjectives() {
    return this.accountService.userHasPermission(Permission.manageVisitObjectivePermission);
  }

  closeAdding(event) {
    this.selectedVisitObjectiveId = undefined;
    this.addNew = false;
    if (event) {
      this.getVisitObjectives();
    }
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }


}
